(() => {
  'use strict';
  if (window.__infoStoreWhatsAppUTMReady) return;
  window.__infoStoreWhatsAppUTMReady = true;

  const STORAGE_KEY = 'infostore_whatsapp_utm_v1';
  const MAX_AGE_MS = 30 * 60 * 1000;
  const HOSTS = new Set(['wa.me', 'api.whatsapp.com', 'web.whatsapp.com']);
  const originalMessages = new WeakMap();
  const clean = (value, length) => String(value || '')
    .replace(/[\u0000-\u001f\u007f()·]/g, ' ')
    .replace(/\s+/g, ' ').trim().slice(0, length);

  const readAttribution = () => {
    const params = new URLSearchParams(window.location.search);
    const source = clean(params.get('utm_source'), 60).toLowerCase()
      || (['gclid', 'gbraid', 'wbraid'].some(key => params.get(key)) ? 'google' : '');
    if (source) {
      const current = { source, campaign: clean(params.get('utm_campaign'), 100), savedAt: Date.now() };
      try { window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(current)); } catch (_) {}
      return current;
    }
    try {
      const stored = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (stored && typeof stored.savedAt === 'number'
          && stored.savedAt <= Date.now() && Date.now() - stored.savedAt < MAX_AGE_MS) {
        const source = clean(stored.source, 60).toLowerCase();
        if (source) return { source, campaign: clean(stored.campaign, 100) };
      }
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
    return null;
  };

  const attribution = readAttribution();
  if (!attribution) return;
  const suffix = '(via ' + [attribution.source, attribution.campaign].filter(Boolean).join(' · ') + ')';

  const updateLink = (link) => {
    if (!(link instanceof HTMLAnchorElement)) return;
    let url;
    try { url = new URL(link.getAttribute('href'), window.location.href); } catch (_) { return; }
    if (!['https:', 'http:'].includes(url.protocol) || !HOSTS.has(url.hostname.toLowerCase())) return;

    if (!originalMessages.has(link)) originalMessages.set(link, url.searchParams.get('text') || '');
    const base = originalMessages.get(link).trim();
    if (base.endsWith(suffix)) return;
    const message = (base ? base + ' ' : '') + suffix;
    if (url.searchParams.get('text') === message) return;
    url.searchParams.set('text', message);
    link.href = url.toString();
  };

  const updateWithin = (node) => {
    if (!(node instanceof Element) && !(node instanceof Document)) return;
    if (node instanceof HTMLAnchorElement) updateLink(node);
    node.querySelectorAll('a[href]').forEach(updateLink);
  };

  const start = () => {
    updateWithin(document);
    const observer = new MutationObserver((records) => {
      records.forEach(record => record.addedNodes.forEach(updateWithin));
    });
    observer.observe(document.body, { childList: true, subtree: true });
    const refreshClickedLink = (event) => {
      if (event.target instanceof Element) updateLink(event.target.closest('a[href]'));
    };
    ['click', 'auxclick', 'contextmenu'].forEach(event => {
      document.addEventListener(event, refreshClickedLink, { capture: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
